<template>
  <div v-if="hasDisease">
    <p class="mt-4 mb-2" ref="title">
      <b>Albuminuria</b>
    </p>
    <v-radio-group
      :value="albuminuria"
      @change="$emit('update:albuminuria', $event)"
      class="mt-0"
    >
      <v-layout wrap justify-space-between align-center>
        <v-flex xs12 md4 v-for="r in albuminuriaRanges" :key="r.value">
          <v-radio :label="r.text" :value="r.value"></v-radio>
        </v-flex>
      </v-layout>
    </v-radio-group>
  </div>
</template>

<script>
export default {
  data: () => ({
    eligibleDiagnosis: ['T89', 'T90', 'K86', 'K87'],
    albuminuriaRanges: [
      { text: 'A1 (<30μg/mg)', value: 0 },
      { text: 'A2 (30-300μg/mg)', value: 30 },
      { text: 'A3 (>300μg/mg)', value: 301 },
    ],
  }),
  props: {
    albuminuria: { type: Number },
    diagnosesICPC: { type: Array, default: () => [] },
  },
  computed: {
    hasDisease() {
      for (let i = 0; i < this.eligibleDiagnosis.length; i++) {
        const targetICPC = this.eligibleDiagnosis[i]
        if (this.diagnosesICPC.includes(targetICPC)) return true
      }
      return false
    },
  },
  watch:{
    diagnosesICPC(){
      if(!this.hasDisease){
        this.$emit('update:albuminuria', null)
      }
    }
  }
}
</script>
